import { render } from "./ListingSearchEmpty.vue?vue&type=template&id=486828fc"
import script from "./ListingSearchEmpty.vue?vue&type=script&setup=true&lang=js"
export * from "./ListingSearchEmpty.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/ListingSearchEmpty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "486828fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('486828fc', __exports__)) {
    api.reload('486828fc', __exports__)
  }
  
  module.hot.accept("./ListingSearchEmpty.vue?vue&type=template&id=486828fc", () => {
    api.rerender('486828fc', render)
  })

}


export default __exports__